import React from "react";
import { styled } from "styled-components";
import { Link } from "gatsby";

const Container = styled.button`
    border-radius: 38px;
    font-family: Montserrat, sans-serif;
    font-size: 22px;
    background-color: ${(props) => (props.active ? "#000" : "#fff")};
    border: none;
    color: ${(props) => (props.active ? "#fff" : "#000")};
    border: 2px solid #000;
    font-weight: normal;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.25s ease-in-out;
    &.shari_williams_memorial_cup {
        display: none;
    }
    &.hidden {
        display: none;
    }
    @media (max-width: 768px) {
        font-size: 18px;
        line-height: 28px;
        max-width: calc(100vw - 2rem);
    }
    &:disabled {
        opacity: 0.2;
        cursor: not-allowed;
        pointer-events: none;
    }
    div.button-inner,
    a {
        white-space: nowrap;
        display: block;
        padding: 22px 55px;
        border-radius: 38px;
        text-decoration: none;
        color: ${(props) => (props.active ? "#fff" : "#000")};
    }
`;

const ButtonWhite = ({ children, link, active, ...rest }) => {
    if (link) {
        return (
            <Container {...rest} active={active}>
                <Link
                    to={link}
                    target={link.includes("http") ? "_blank" : "_self"}
                >
                    {children}
                </Link>
            </Container>
        );
    } else {
        return (
            <Container {...rest} active={active}>
                <div className="button-inner">{children}</div>
            </Container>
        );
    }
};

export default ButtonWhite;
